<template>
    <div style="display: inline;">
      <!-- table表格 -->
      <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/customer/renewal/page" getKey="rows" :columns="columns">
        <!-- 搜索框插槽 -->
        <template #conditions>
          <div class="card-grid-container" style="display: flex;">
            <div class="gridStyle">
              <div style="">{{$t('chuangjianshijian')}}</div>
              <div>{{ dayjs(customerInfo.createTime).format('YYYY-MM-DD') }}</div>
            </div>
            <div class="gridStyle">
              <div>{{$t('shixiaoshijian')}}</div>
              <div>{{ customerInfo.endTime && dayjs(customerInfo.endTime).format('YYYY-MM-DD') }}</div>
            </div>
            <div class="gridStyle">
              <div>{{$t('shengyutianshu')}}</div>
              <div>{{ leftDays() }}</div>
            </div>
          </div>
        </template>
        <!-- 左侧按钮插槽 -->
        <template #buttonsL>
          <div style="font-size: 16px; margin: 10px;color: #419fff;">{{$t('xuqixinxi')}}</div>
        </template>
        <template #xuqikaishishijian="scope">
          <span>{{ dayjs(scope.row.beginTime).format('YYYY-MM-DD') }}</span>
        </template>
        <template #xuqijieshushijian="scope">
          <span>{{ dayjs(scope.row.endTime).format('YYYY-MM-DD') }}</span>
        </template>
      </yi_curd_table>
    </div>
</template>

<script>
export default {
  name: 'web_system_renewal_information_list',
  components: {},
  data(){
    return {
      customerInfo: {},
      columns: [
        {
          label: 'xuqikaishishijian',
          prop: 'beginTime',
          type: 'slot',
        },
        {
          label: 'xuqijieshushijian',
          prop: 'endTime',
          type: 'slot',
        },
        {
          label: 'bencixuqitianshu',
          prop: 'day'
        },
        {
          label: 'beizhu',
          prop: 'remark'
        },
      ]
    }
  },
  created() {
    this.http.get('/web/customer/get?id='+localStorage.getItem('customerId')).then(res => {
      this.customerInfo = res.data;
    });
    setTimeout(() => {
      this.$set(this.yt, 'conditions', {customerId: localStorage.getItem('customerId')});
      this.yt.get(1);
    }, 300);
  },
  methods: {
    // 剩余天数
    leftDays() {
      let endTime = this.customerInfo.endTime;
      if (endTime) {
        let startTime = new Date().getTime();
        let leftDays = (endTime / 1000 / 3600 / 24).toFixed(0) - (startTime / 1000 / 3600 / 24).toFixed(0);
        return leftDays >= 0 ? leftDays : '';
      }
      return '';
    },
  },
}
</script>

<style scoped lang="scss">
.card-grid-container {
  display: flex;
  flex-wrap: wrap;
}
.gridStyle {
  width: 33%;
  cursor: pointer;
  padding: 68px;
  font-size: 22px;
  text-align: center;
  font-weight: bold;
}
</style>